// ═══════════════════════════════════════════════════════════════
// AI POLICE — MISTRAL API HELPER
// Calls Netlify Function proxy (/api/chat)
// Demo mode with fallback to static responses
// ═══════════════════════════════════════════════════════════════

import SYSTEM_PROMPTS from '../data/prompts';

const API_URL = '/api/chat';

export async function sendMessage({ module, message, lang, history = [], mode = 'agent' }) {
  const systemPrompt = SYSTEM_PROMPTS[module]?.[lang] || SYSTEM_PROMPTS[module]?.nl || '';

  try {
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        systemPrompt,
        message,
        lang,
        module,
        mode,
        history: history.slice(-10), // Last 10 messages for context
      }),
    });

    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();
    return { success: true, content: data.content };
  } catch (error) {
    console.warn('Mistral API unavailable, using demo mode:', error.message);
    return { success: false, content: null, error: error.message };
  }
}

export function isApiAvailable() {
  // Check if we're on Netlify (has the function endpoint)
  return window.location.hostname !== 'localhost' || 
         process.env.REACT_APP_DEMO_MODE !== 'true';
}
